import { useMemo } from 'react';

import { renderModel } from '../util/renderModel';

export const useIsWixStudio = () =>
  useMemo(() => {
    const queryParams = renderModel.getQueryParams();
    return queryParams.brand === 'WixStudio';
  }, []);
